import React from 'react'
import Grid from '@material-ui/core/Grid'
import useInnerHTML from 'hooks/useInnerHtml'

const Title = ({
  title: _title = '',
  setTitle: _setTitle
}) => {
  const handleOnChange = ({ target: { value } }) => _setTitle(value)
  const { innerHTML: title } = useInnerHTML(_title)

  return (
    <Grid item xs={12} className=''>
      <Grid container className='b'>
        <Grid item xs={3} className='pl6'>
          <label htmlFor='title'>Title</label>
        </Grid>
        <Grid item xs={9} className='pl8 pr3'>
          <input
            className='w-100 ml3'
            type='text'
            name='title'
            value={title}
            onChange={handleOnChange}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Title
